module.exports = {
  appUrl: 'https://www.groovehq.com/',
  widgetUrl: 'https://widget-cluster.production.groovehq.com',
  appDomain: 'groovehq.com',
  kbProxyDomain: 'hosting.groovehq.help',
  api_url: 'https://api.production.groovehq.com',
  autologin_url: 'https://api.groovehq.com',
  graphql_url: 'https://graphql.production.groovehq.com/graphql',
  app_graphql_url: 'https://api.production.groovehq.com/v2/graphql',
  report_url: 'https://graphql.production.groovehq.com/reports',
  embeddable_cards_url:
    'https://graphql.production.groovehq.com/embeddable_cards/proxy',
  realtime_url: 'realtime.groovehq.com',
  s3_url: 's3.amazonaws.com',
  vapidPublicKey:
    'BLfQ4bJBOxnoWU7qeWM_11uetqQoMoecfTvmGZHJZFf_o2Yjm2IMjP5rh05OuHBvN3fltG6INifMi5EfIVdwnuI=',
  stripePublicKey: 'pk_live_TUyxO0NZ4mGfVntGxql5FC1900Lgtmu1Qs',
  filestackKey: 'AbnxTnzehQ4KY9hgqQ767z',
  filestackRegion: 'us-east-1',
  filestackBucket: 'groove-filestack-production',
  showReports: true,
  showSettings: true,
  api_concurrency: 20,
  gtm_segment: 'Application',
  gtm_version: 'beta',
  gtm_containerid: 'GTM-MQ94GV3',
  gtm_auth: 'gTuZYzA0PueTz4F77TZkNA',
  gtm_preview: 'env-2',
  google_recaptcha_site_key: '6Lf8nH0UAAAAAFSIpT4Ylg1p4qqSswMEBmAuAFeO',
  integrationsApiUrl: 'https://integrations.production.groovehq.com',
  integrationsApiConcurrency: 4,
  githubAppName: 'groovehq',
  chatServerUrl: 'https://chat-server-cluster.production.groovehq.com',
  chatIdentityServerUrl: 'https://vector.im',
  emojiWidth: 280,
  emojiHeight: 399,
  uploaderUrl: 'https://uploader.production.groovehq.com',
  trialDays: 15,
}
